webpackJsonp([3,48,49,160,161,162,163,164,165,166,167,296,297],{

/***/ 1000:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            gallery: false,
            al: {
                hasGrayscale: true,
                itemsToShow: 2,
                breakpoints: {
                    768: {
                        hasGrayscale: false,
                        itemsToShow: 4
                    },
                    960: {
                        hasGrayscale: true,
                        itemsToShow: 6
                    }
                }
            },
            items: [{
                title: 'Slide 1',
                image: 'https://picsum.photos/id/0/1230/500'
            }, {
                title: 'Slide 2',
                image: 'https://picsum.photos/id/1/1230/500'
            }, {
                title: 'Slide 3',
                image: 'https://picsum.photos/id/2/1230/500'
            }, {
                title: 'Slide 4',
                image: 'https://picsum.photos/id/3/1230/500'
            }, {
                title: 'Slide 5',
                image: 'https://picsum.photos/id/4/1230/500'
            }, {
                title: 'Slide 6',
                image: 'https://picsum.photos/id/5/1230/500'
            }, {
                title: 'Slide 7',
                image: 'https://picsum.photos/id/6/1230/500'
            }, {
                title: 'Slide 8',
                image: 'https://picsum.photos/id/7/1230/500'
            }]
        };
    },

    methods: {
        switchGallery: function switchGallery(value) {
            this.gallery = value;
            if (value) {
                return document.documentElement.classList.add('is-clipped');
            } else {
                return document.documentElement.classList.remove('is-clipped');
            }
        }
    }
});

/***/ }),

/***/ 1001:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel', {
    attrs: {
      "autoplay": false,
      "with-carousel-list": "",
      "indicator": false,
      "overlay": _vm.gallery
    },
    scopedSlots: _vm._u([{
      key: "list",
      fn: function(props) {
        return [_c('b-carousel-list', {
          attrs: {
            "data": _vm.items,
            "config": _vm.al,
            "refresh": _vm.gallery,
            "as-indicator": ""
          },
          on: {
            "switch": function($event) {
              props.switch($event, false)
            }
          },
          model: {
            value: (props.active),
            callback: function($$v) {
              _vm.$set(props, "active", $$v)
            },
            expression: "props.active"
          }
        })]
      }
    }])
  }, [_vm._l((_vm.items), function(item, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('figure', {
      staticClass: "image",
      on: {
        "click": function($event) {
          _vm.switchGallery(true)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.image
      }
    })])])
  }), _vm._v(" "), (_vm.gallery) ? _c('span', {
    staticClass: "modal-close is-large",
    on: {
      "click": function($event) {
        _vm.switchGallery(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('template', {
    slot: "overlay"
  }, [_c('div', {
    staticClass: "has-text-centered has-text-white"
  }, [_vm._v("\n                Hello i'am overlay!\n            ")])])], 2)
},staticRenderFns: []}

/***/ }),

/***/ 113:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    title: 'Carousel',
    props: [{
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'Number',
        values: '—',
        default: '<code>0</code>'
    }, {
        name: '<code>animated</code>',
        description: 'Transition effect',
        type: 'String',
        values: '<code>fade</code>, <code>slide</code>',
        default: '<code>slide</code>'
    }, {
        name: '<code>interval</code>',
        description: 'Interval of the <code>autoplay</code>, in milliseconds',
        type: 'Number',
        values: '—',
        default: '<code>3500</code>'
    }, {
        name: '<code>has-drag</code>',
        description: 'Toggle touch dragging, when touch not detected. auto switch mouse dragging',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>autoplay</code>',
        description: 'Whether automatically loop the slides',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>pause-hover</code>',
        description: 'Pause carousel when autoplay and mouse enter',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>pause-info</code>',
        description: 'Show infomation pause when autoplay and mouse enter',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>pause-info-type</code>',
        description: 'Type (color) of the pause-info, optional',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '<code>is-white</code>'
    }, {
        name: '<code>pause-text</code>',
        description: 'Text when pause',
        type: 'String',
        values: '—',
        default: '<code>Pause</code>'
    }, {
        name: '<code>arrow</code>',
        description: '	Display the "next" and "prev" action',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>arrow-both</code>',
        description: 'Display the "next" and "prev" action when first or last item',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>arrow-hover</code>',
        description: 'Display the "next" and "prev" action when hover, but hidden on mobile',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>icon-pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '<code>mdi</code>, <code>fa</code>, <code>fas</code>, <code>far</code>, <code>fab</code>,  <code>fad</code>, <code>fal</code>',
        default: '<code>mdi</code>'
    }, {
        name: '<code>icon-size</code>',
        description: 'Arrow icon size, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '<code>—</code>'
    }, {
        name: '<code>icon-prev</code>',
        description: 'Icon to use for previous arrow',
        type: 'String',
        values: '—',
        default: '<code>chevron-left</code>'
    }, {
        name: '<code>icon-next</code>',
        description: 'Icon to use for next arrow',
        type: 'String',
        values: '—',
        default: '<code>chevron-right</code>'
    }, {
        name: '<code>indicator</code>',
        description: 'Display the indicator for jumping to specific item',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>indicator-background</code>',
        description: 'Added background for indicator',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>indicator-custom</code>',
        description: 'use when the image is more than 6 so that the indicator is not too small',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>indicator-custom-size</code>',
        description: 'image size on the indicator when the <code>indicator-custom</code> is used',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>',
        default: '<code>is-small</code>'
    }, {
        name: '<code>indicator-inside</code>',
        description: 'Display the indicator inside on carousel',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>indicator-mode</code>',
        description: 'Trigger for action indicator',
        type: 'String',
        values: '<code>click</code>, <code>hover</code>',
        default: '<code>click</code>'
    }, {
        name: '<code>indicator-position</code>',
        description: 'Position indicator only when <code>indicator-inside</code>',
        type: 'String',
        values: '<code>is-bottom</code>, <code>is-top</code>',
        default: '<code>is-bottom</code>'
    }, {
        name: '<code>indicator-style</code>',
        description: 'Style for indicator of carousel',
        type: 'String',
        values: '<code>is-boxes</code>, <code>is-dots</code>, <code>is-lines</code>',
        default: '<code>is-dots</code>'
    }, {
        name: '<code>overlay</code>',
        description: 'Switch like a gallery',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>progress</code>',
        description: 'Display the progress item of carousel',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>progress-type</code>',
        description: 'Type (color) of the progress, optional',
        type: 'String',
        values: '<code>is-white</code>, <code>is-black</code>, <code>is-light</code>,\n                    <code>is-dark</code>, <code>is-primary</code>, <code>is-info</code>, <code>is-success</code>,\n                    <code>is-warning</code>, <code>is-danger</code>,\n                    and any other colors you\'ve set in the <code>$colors</code> list on Sass',
        default: '<code>is-primary</code>'
    }, {
        name: '<code>with-carousel-list</code>',
        description: 'use this when indicator custom with <code>b-carousel-list</code>',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }],
    slots: [{
        name: '<code>indicators</code>',
        description: 'Custom indicators',
        props: '<code>i: Number</code>'
    }, {
        name: '<code>list</code>',
        description: 'Custom indicators When <code>with-carousel-list</code>',
        props: '<code>active: Number</code>, <code>switch: Number</code>'
    }, {
        name: '<code>overlay</code>',
        description: 'Custom other when overlay',
        props: '—'
    }],
    events: [{
        name: '<code>change</code>',
        description: 'Triggers when carousel item value is changed',
        parameters: '<code>value: Boolean</code>, <code>value: String</code>'
    }, {
        name: '<code>input</code>',
        description: 'Triggers when <code>indicator-mode</code> value is changed',
        parameters: '<code>value: Boolean</code>, <code>value: String</code>'
    }]
}, {
    title: 'Carousel List',
    props: [{
        name: '<code>v-model</code>',
        description: 'Binding value',
        type: 'Number',
        values: '—',
        default: '<code>0</code>'
    }, {
        name: '<code>data</code>',
        description: 'Carousel-list data',
        type: 'Array',
        values: '—',
        default: '—'
    }, {
        name: '<code>config</code>',
        description: 'An object to pass all configs',
        type: 'Object',
        values: '—',
        default: '—'
    }, {
        name: '<code>has-drag</code>',
        description: 'Toggle touch dragging, when touch not detected. auto switch mouse dragging',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>has-grayscale</code>',
        description: 'Give a effect grayscale on img',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>has-opacity</code>',
        description: 'Give a effect opacity on img',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>repeat</code>',
        description: 'Back to value 0 when item active same with total data',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>items-to-show</code>',
        description: 'count of items to showed per view (support a decimal).',
        type: 'Number',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>items-to-list</code>',
        description: 'count of items to list when use navigation buttons',
        type: 'Number',
        values: '<code>1-5</code>',
        default: '<code>1</code>'
    }, {
        name: '<code>as-indicator</code>',
        description: 'Switch mode to indicator for carousel',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>refresh</code>',
        description: 'Refresh for overlay carousel',
        type: 'Boolean',
        values: '—',
        default: '<code>false</code>'
    }, {
        name: '<code>arrow</code>',
        description: 'Display the "next" or "prev" action when first or last item',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>arrow-hover</code>',
        description: 'Display Arrow action when hover, but hidden on mobile',
        type: 'Boolean',
        values: '—',
        default: '<code>true</code>'
    }, {
        name: '<code>icon-pack</code>',
        description: 'Icon pack to use',
        type: 'String',
        values: '<code>mdi</code>, <code>fa</code>, <code>fas</code>, <code>far</code>, <code>fab</code>,  <code>fad</code>, <code>fal</code>',
        default: '<code>mdi</code>'
    }, {
        name: '<code>icon-size</code>',
        description: 'Arrow icon size, optional',
        type: 'String',
        values: '<code>is-small</code>, <code>is-medium</code>, <code>is-large</code>',
        default: '<code>—</code>'
    }, {
        name: '<code>icon-prev</code>',
        description: 'Icon to use for previous arrow',
        type: 'String',
        values: '—',
        default: '<code>chevron-left</code>'
    }, {
        name: '<code>icon-next</code>',
        description: 'Icon to use for next arrow',
        type: 'String',
        values: '—',
        default: '<code>chevron-right</code>'
    }],
    slots: [{
        name: '<code>item</code>',
        description: 'Custom item',
        props: '<code>list: Array</code>, <code>index: Number</code>, <code>active: Number</code>'
    }],
    events: [{
        name: '<code>switch</code>',
        description: 'Triggers when value is changed',
        parameters: '<code>value: Boolean</code>, <code>value: Number</code>, <code>value: String</code>'
    }]
}]);

/***/ }),

/***/ 114:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ([{
    name: '<code>$carousel-min-height</code>',
    description: 'The carousel default height before image loaded',
    default: '<code>120px</code>'
}, {
    name: '<code>$carousel-arrow-background</code>',
    description: 'The carousel arrow background',
    default: '<code>$white</code>'
}, {
    name: '<code>$carousel-arrow-color</code>',
    description: 'The carousel color border',
    default: '<code>$primary</code>'
}, {
    name: '<code>$carousel-arrow-icon-spaced</code>',
    description: 'The carousel arrow icon spaced left and right',
    default: '<code>1.5rem</code>'
}, {
    name: '<code>$carousel-arrow-top</code>',
    description: 'The carousel position by top',
    default: '<code>50%</code>'
}, {
    name: '<code>$carousel-indicator-background</code>',
    description: 'The carousel indicator background',
    default: '<code>rgba($black, 0.45)</code>'
}, {
    name: '<code>$carousel-indicator-border</code>',
    description: 'The carousel indicator color border',
    default: '<code>$primary</code>'
}, {
    name: '<code>$carousel-indicator-color</code>',
    description: 'The carousel indicator background',
    default: '<code>$white</code>'
}, {
    name: '<code>$carousel-indicator-spaced</code>',
    description: 'The carousel indicator spaced',
    default: '<code>.5rem</code>'
}, {
    name: '<code>$carousel-overlay-background</code>',
    description: 'The carousel background when overlay',
    default: '<code>rgba($black, 0.86)</code>'
}, {
    name: '<code>$carousel-overlay-z</code>',
    description: 'The carousel z-index for overlay',
    default: '<code>40</code>'
}]);

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(978),
  /* template */
  __webpack_require__(979),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(980),
  /* template */
  __webpack_require__(981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(982),
  /* template */
  __webpack_require__(983),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(984),
  /* template */
  __webpack_require__(985),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(986),
  /* template */
  __webpack_require__(987),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(988)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(990),
  /* template */
  __webpack_require__(991),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(992)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(994),
  /* template */
  __webpack_require__(995),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(996),
  /* template */
  __webpack_require__(997),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(998),
  /* template */
  __webpack_require__(999),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1000),
  /* template */
  __webpack_require__(1001),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_carousel__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__variables_carousel__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExFull__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__examples_ExFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__examples_ExFull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExArrow__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__examples_ExArrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__examples_ExArrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExProgress__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_ExProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__examples_ExProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExIndicator__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__examples_ExIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__examples_ExIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExCustomIndicator__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__examples_ExCustomIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__examples_ExCustomIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExGallery__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__examples_ExGallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__examples_ExGallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExCarouselList__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__examples_ExCarouselList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__examples_ExCarouselList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExWithCard__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__examples_ExWithCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__examples_ExWithCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__examples_ExWithList__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__examples_ExWithList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__examples_ExWithList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExSimple__ = __webpack_require__(1327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExSimple___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExSimple__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExFull__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExFull___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExFull__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__raw_loader_examples_ExArrow__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__raw_loader_examples_ExArrow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__raw_loader_examples_ExArrow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExProgress__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExProgress___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExProgress__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__raw_loader_examples_ExIndicator__ = __webpack_require__(1331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__raw_loader_examples_ExIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__raw_loader_examples_ExIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExCustomIndicator__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExCustomIndicator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExCustomIndicator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__raw_loader_examples_ExGallery__ = __webpack_require__(1333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__raw_loader_examples_ExGallery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__raw_loader_examples_ExGallery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExCarouselList__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExCarouselList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExCarouselList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__raw_loader_examples_ExWithCard__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__raw_loader_examples_ExWithCard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__raw_loader_examples_ExWithCard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raw_loader_examples_ExWithList__ = __webpack_require__(1336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__raw_loader_examples_ExWithList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__raw_loader_examples_ExWithList__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


























/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            api: __WEBPACK_IMPORTED_MODULE_0__api_carousel__["default"],
            variables: __WEBPACK_IMPORTED_MODULE_1__variables_carousel__["default"],
            ExSimple: __WEBPACK_IMPORTED_MODULE_2__examples_ExSimple___default.a,
            ExFull: __WEBPACK_IMPORTED_MODULE_3__examples_ExFull___default.a,
            ExArrow: __WEBPACK_IMPORTED_MODULE_4__examples_ExArrow___default.a,
            ExIndicator: __WEBPACK_IMPORTED_MODULE_6__examples_ExIndicator___default.a,
            ExProgress: __WEBPACK_IMPORTED_MODULE_5__examples_ExProgress___default.a,
            ExCustomIndicator: __WEBPACK_IMPORTED_MODULE_7__examples_ExCustomIndicator___default.a,
            ExGallery: __WEBPACK_IMPORTED_MODULE_8__examples_ExGallery___default.a,
            ExCarouselList: __WEBPACK_IMPORTED_MODULE_9__examples_ExCarouselList___default.a,
            ExWithCard: __WEBPACK_IMPORTED_MODULE_10__examples_ExWithCard___default.a,
            ExWithList: __WEBPACK_IMPORTED_MODULE_11__examples_ExWithList___default.a,
            ExSimpleCode: __WEBPACK_IMPORTED_MODULE_12__raw_loader_examples_ExSimple___default.a,
            ExFullCode: __WEBPACK_IMPORTED_MODULE_13__raw_loader_examples_ExFull___default.a,
            ExArrowCode: __WEBPACK_IMPORTED_MODULE_14__raw_loader_examples_ExArrow___default.a,
            ExProgressCode: __WEBPACK_IMPORTED_MODULE_15__raw_loader_examples_ExProgress___default.a,
            ExIndicatorCode: __WEBPACK_IMPORTED_MODULE_16__raw_loader_examples_ExIndicator___default.a,
            ExCustomIndicatorCode: __WEBPACK_IMPORTED_MODULE_17__raw_loader_examples_ExCustomIndicator___default.a,
            ExGalleryCode: __WEBPACK_IMPORTED_MODULE_18__raw_loader_examples_ExGallery___default.a,
            ExCarouselListCode: __WEBPACK_IMPORTED_MODULE_19__raw_loader_examples_ExCarouselList___default.a,
            ExWithCardCode: __WEBPACK_IMPORTED_MODULE_20__raw_loader_examples_ExWithCard___default.a,
            ExWithListCode: __WEBPACK_IMPORTED_MODULE_21__raw_loader_examples_ExWithList___default.a
        };
    }
});

/***/ }),

/***/ 1327:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-carousel>\n        <b-carousel-item v-for=\"(carousel, i) in carousels\" :key=\"i\">\n            <section :class=\"`hero is-medium is-${carousel.color}`\">\n                <div class=\"hero-body has-text-centered\">\n                    <h1 class=\"title\">{{carousel.text}}</h1>\n                </div>\n            </section>\n        </b-carousel-item>           \n    </b-carousel>\n</template>\n\n<script>\nexport default {\n    data(){\n        return {\n            carousels: [\n                { text: 'Slide 1', color: 'primary' },\n                { text: 'Slide 2', color: 'info' },\n                { text: 'Slide 3', color: 'success' },\n                { text: 'Slide 4', color: 'warning' },\n                { text: 'Slide 5', color: 'danger' }\n            ]\n        }\n    }\n}\n</script>\n"

/***/ }),

/***/ 1328:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div style=\"padding: 1.5rem\">\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-switch v-model=\"autoPlay\">Autoplay</b-switch>\n                <b-switch v-model=\"pauseHover\" :disabled=\"!autoPlay\">Pause on hover</b-switch>\n                <b-switch v-model=\"pauseInfo\" :disabled=\"!pauseHover\">Pause info</b-switch>\n                <b-switch v-model=\"drag\">Drag event</b-switch>\n            </b-field><br>\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-field label=\"Value\">\n                    <b-numberinput v-model=\"carousel\" min=\"0\" :max=\"carousels.length - 1\" controls-position=\"compact\"/>\n                </b-field>\n                <b-field label=\"Interval\">\n                    <b-numberinput v-model=\"interval\" min=\"0\" controls-position=\"compact\" step=\"1000\" :disabled=\"!autoPlay\"/>\n                </b-field>\n                <b-field label=\"Animated\">\n                    <b-field>\n                        <b-radio-button v-model=\"animated\"\n                            native-value=\"fade\">\n                            Fade\n                        </b-radio-button>\n                        <b-radio-button v-model=\"animated\"\n                            native-value=\"slide\">\n                            Slide\n                        </b-radio-button>\n                    </b-field>\n                </b-field>\n                <b-field label=\"Pause Type\">\n                    <b-select v-model=\"pauseType\" :disabled=\"!pauseInfo\">\n                        <option value=\"is-white\">is-white</option>\n                        <option value=\"is-dark\">is-dark</option>\n                        <option value=\"is-primary\">is-primary</option>\n                    </b-select>\n                </b-field>\n            </b-field>\n        </div>\n\n        <b-carousel\n            v-model=\"carousel\"\n            :animated=\"animated\"\n            :has-drag=\"drag\"\n            :autoplay=\"autoPlay\"\n            :pause-hover=\"pauseHover\"\n            :pause-info=\"pauseInfo\"\n            :pause-info-type=\"pauseType\"\n            :interval=\"interval\"\n            @change=\"info($event)\">\n            <b-carousel-item v-for=\"(carousel, i) in carousels\" :key=\"i\">\n                <section :class=\"`hero is-medium is-${carousel.color} is-bold`\">\n                    <div class=\"hero-body has-text-centered\">\n                        <h1 class=\"title\">{{carousel.title}}</h1>\n                    </div>\n                </section>\n            </b-carousel-item>\n        </b-carousel>\n    </section>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            carousel: 0,\n            animated: 'fade',\n            drag: false,\n            autoPlay: false,\n            pauseHover: false,\n            pauseInfo: false,\n            pauseType: 'is-primary',\n            interval: 3000,\n            carousels: [\n                { title: 'Slide 1', color: 'dark' },\n                { title: 'Slide 2', color: 'primary' },\n                { title: 'Slide 3', color: 'info' },\n                { title: 'Slide 4', color: 'success' },\n                { title: 'Slide 5', color: 'warning' },\n                { title: 'Slide 6', color: 'danger' }\n            ]\n        }\n    },\n    methods: {\n        info(value) {\n            this.carousel = value\n            this.$buefy.toast.open({\n                message: `This Slide ${value} !`,\n                type: 'is-info'\n            })\n        }\n    }\n}\n</script>\n"

/***/ }),

/***/ 1329:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div style=\"padding: 1.5rem\">\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-switch v-model=\"arrow\"><strong>Arrow</strong></b-switch>\n                <b-switch v-model=\"arrowBoth\" :disabled=\"!arrow\">Both</b-switch>\n                <b-switch v-model=\"arrowHover\" :disabled=\"!arrow\">Hover</b-switch>\n            </b-field><br>\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-field label=\"Icon Pack\">\n                    <b-input v-model=\"iconPack\" placeholder=\"e.g. mdi, fa or other\"/>\n                </b-field>\n                <b-field label=\"Icon Size\">\n                    <b-select v-model=\"iconSize\">\n                        <option value=\"\">default</option>\n                        <option value=\"is-small\">is-small</option>\n                        <option value=\"is-medium\">is-medium</option>\n                        <option value=\"is-large\">is-large</option>\n                    </b-select>\n                </b-field>\n                <b-field label=\"Icon Prev\">\n                    <b-input v-model=\"iconPrev\"/>\n                </b-field>\n                <b-field label=\"Icon Next\">\n                    <b-input v-model=\"iconNext\"/>\n                </b-field>\n            </b-field>\n        </div>\n\n        <b-carousel\n            :arrow=\"arrow\"\n            :arrow-both=\"arrowBoth\"\n            :arrow-hover=\"arrowHover\"\n            :icon-pack=\"iconPack\"\n            :icon-prev=\"iconPrev\"\n            :icon-next=\"iconNext\"\n            :icon-size=\"iconSize\">\n            <b-carousel-item v-for=\"(carousel, i) in carousels\" :key=\"i\">\n                <section :class=\"`hero is-medium is-${carousel.color}`\">\n                    <div class=\"hero-body has-text-centered\">\n                        <h1 class=\"title\">{{carousel.title}}</h1>\n                    </div>\n                </section>\n            </b-carousel-item>\n        </b-carousel>\n    </section>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            arrow: true,\n            arrowBoth: false,\n            arrowHover: false,\n            iconPack: 'mdi',\n            iconPrev: 'arrow-left',\n            iconNext: 'arrow-right',\n            iconSize: '',\n            carousels: [\n                { title: 'Slide 1', color: 'info' },\n                { title: 'Slide 2', color: 'success' },\n                { title: 'Slide 3', color: 'warning' },\n                { title: 'Slide 4', color: 'danger' }\n            ]\n        }\n    }\n}\n</script>\n"

/***/ }),

/***/ 1330:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div style=\"padding: 1.5rem\">\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-field>\n                    <b-switch v-model=\"progress\"><strong>Progress</strong></b-switch>\n                </b-field>\n                <b-field label=\"Type\" label-position=\"on-border\">\n                    <b-select v-model=\"progressType\" :disabled=\"!progress\">\n                        <option value=\"is-primary\">is-primary</option>\n                        <option value=\"is-info\">is-info</option>\n                        <option value=\"is-success\">is-success</option>\n                        <option value=\"is-warning\">is-warning</option>\n                        <option value=\"is-danger\">is-danger</option>\n                        <option value=\"is-white\">is-white</option>\n                        <option value=\"is-light\">is-light</option>\n                        <option value=\"is-dark\">is-dark</option>\n                    </b-select>\n                </b-field>\n            </b-field>\n        </div>\n\n        <b-carousel\n            :progress=\"progress\"\n            :progress-type=\"progressType\">\n            <b-carousel-item v-for=\"(carousel, i) in carousels\" :key=\"i\">\n                <section :class=\"`hero is-medium is-${carousel.color}`\">\n                    <div class=\"hero-body has-text-centered\">\n                        <h1 class=\"title\">{{carousel.title}}</h1>\n                    </div>\n                </section>\n            </b-carousel-item>\n        </b-carousel>\n    </section>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            progress: true,\n            progressType: 'is-primary',\n            carousels: [\n                { title: 'Slide 1', color: 'grey' },\n                { title: 'Slide 2', color: 'dark' },\n                { title: 'Slide 3', color: 'primary' },\n                { title: 'Slide 4', color: 'info' }\n            ]\n        }\n    }\n}\n</script>\n"

/***/ }),

/***/ 1331:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div style=\"padding: 1.5rem\">\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-switch v-model=\"indicator\"><strong>Indicator</strong></b-switch>\n                <b-switch v-model=\"indicatorBackground\" :disabled=\"!indicator\">Background</b-switch>\n                <b-switch v-model=\"indicatorInside\" :disabled=\"!indicator\">Inside</b-switch>\n            </b-field><br>\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-field label=\"Position\" :disabled=\"!indicator\">\n                    <b-select v-model=\"indicatorPosition\">\n                        <option value=\"is-bottom\">is-bottom</option>\n                        <option value=\"is-top\">is-top</option>\n                    </b-select>\n                </b-field>\n                <b-field label=\"Mode\">\n                    <b-field>\n                        <b-radio-button v-model=\"indicatorMode\" native-value=\"click\" :disabled=\"!indicator\">\n                            <span>Click</span>\n                        </b-radio-button>\n                        <b-radio-button v-model=\"indicatorMode\" native-value=\"hover\" :disabled=\"!indicator\">\n                            <span>Hover</span>\n                        </b-radio-button>\n                    </b-field>\n                </b-field>\n                <b-field label=\"Style\">\n                    <b-field>\n                        <b-radio-button v-model=\"indicatorStyle\" native-value=\"is-boxs\" :disabled=\"!indicator\">\n                            <span>Boxs</span>\n                        </b-radio-button>\n                        <b-radio-button v-model=\"indicatorStyle\" native-value=\"is-dots\" :disabled=\"!indicator\">\n                            <span>Dots</span>\n                        </b-radio-button>\n                        <b-radio-button v-model=\"indicatorStyle\" native-value=\"is-lines\" :disabled=\"!indicator\">\n                            <span>Lines</span>\n                        </b-radio-button>\n                    </b-field>\n                </b-field>\n            </b-field>\n        </div>\n\n        <b-carousel\n            :indicator=\"indicator\"\n            :indicator-background=\"indicatorBackground\"\n            :indicator-inside=\"indicatorInside\"\n            :indicator-mode=\"indicatorMode\"\n            :indicator-position=\"indicatorPosition\"\n            :indicator-style=\"indicatorStyle\">\n            <b-carousel-item v-for=\"(carousel, i) in carousels\" :key=\"i\">\n                <section :class=\"`hero is-medium is-${carousel.color}`\">\n                    <div class=\"hero-body has-text-centered\">\n                        <h1 class=\"title\">{{carousel.title}}</h1>\n                    </div>\n                </section>\n            </b-carousel-item>\n        </b-carousel>\n    </section>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            indicator: true,\n            indicatorBackground: true,\n            indicatorInside: true,\n            indicatorMode: 'hover',\n            indicatorPosition: 'is-top',\n            indicatorStyle: 'is-lines',\n            carousels: [\n                { title: 'Slide 1', color: 'info' },\n                { title: 'Slide 2', color: 'success' },\n                { title: 'Slide 3', color: 'warning' },\n                { title: 'Slide 4', color: 'danger' }\n            ]\n        }\n    }\n}\n</script>\n"

/***/ }),

/***/ 1332:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-carousel :indicator-inside=\"false\">\n        <b-carousel-item v-for=\"(item, i) in 6\" :key=\"i\">\n            <span class=\"image\">\n              <img :src=\"getImgUrl(i)\">\n            </span>\n        </b-carousel-item>\n        <template slot=\"indicators\" slot-scope=\"props\">\n            <span class=\"al image\">\n                <img :src=\"getImgUrl(props.i)\" :title=\"props.i\">\n            </span>\n        </template>\n    </b-carousel>\n</template>\n\n<script>\nexport default {\n    methods: {\n      getImgUrl(value) {\n          return `https://picsum.photos/id/43${value}/1230/500`\n      }\n    }\n}\n</script>\n\n<style>\n.is-active .al img {\n    filter: grayscale(0%);\n}\n.al img {\n    filter: grayscale(100%);\n}\n</style>\n"

/***/ }),

/***/ 1333:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-carousel :autoplay=\"false\" indicator-custom :indicator-inside=\"false\" :overlay=\"gallery\">\n        <b-carousel-item v-for=\"(item, i) in 20\" :key=\"i\">\n            <a @click=\"switchGallery(true)\" class=\"image \">\n                <img :src=\"getImgUrl(i)\">\n            </a>\n        </b-carousel-item>\n        <span v-if=\"gallery\" @click=\"switchGallery(false)\" class=\"modal-close is-large\"/>\n        <template slot=\"indicators\" slot-scope=\"props\">\n            <figure class=\"al image\" :draggable=\"false\">\n                <img :draggable=\"false\" :src=\"getImgUrl(props.i)\" :title=\"props.i\">\n            </figure>\n        </template>\n    </b-carousel>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            gallery: false\n        }\n    },\n    methods: {\n        getImgUrl(value) {\n            value += 50\n            return `https://picsum.photos/id/10${value}/1230/500`\n        },\n        switchGallery(value) {\n            this.gallery = value\n            if (value) {\n                return document.documentElement.classList.add('is-clipped')\n            } else {\n                return document.documentElement.classList.remove('is-clipped')\n            }\n        }\n    }\n}\n</script>\n\n<style>\n.is-active .al img {\n    border: 1px solid #fff;\n    filter: grayscale(0%);\n}\n.al img {\n    border: 1px solid transparent;\n    filter: grayscale(100%);\n}\n</style>\n"

/***/ }),

/***/ 1334:
/***/ (function(module, exports) {

module.exports = "<template>\n    <section>\n        <div style=\"padding: 1.5rem\">\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-switch v-model=\"arrow\">Arrow</b-switch>\n                <b-switch v-model=\"arrowHover\" :disabled=\"!arrow\">Arrow on hover</b-switch>\n                <b-switch v-model=\"drag\">Drag event</b-switch>\n                <b-switch v-model=\"gray\" :disabled=\"opacity\">Grayscale</b-switch>\n                <b-switch v-model=\"opacity\" :disabled=\"gray\">Opacity</b-switch>\n                <b-switch v-model=\"repeat\">Repeat</b-switch>\n            </b-field><br>\n            <b-field grouped group-multiline position=\"is-centered\">\n                <b-field label=\"Value\">\n                    <b-numberinput v-model=\"values\" min=\"0\" :max=\"items.length - 1\" controls-position=\"compact\"/>\n                </b-field>\n                <b-field label=\"Items to List\">\n                    <b-numberinput v-model=\"perList\" min=\"0\" :max=\"items.length - 1\" controls-position=\"compact\"/>\n                </b-field>\n            </b-field>\n        </div>\n        <b-carousel-list\n            v-model=\"values\"\n            :data=\"items\"\n            :arrow=\"arrow\"\n            :arrow-hover=\"arrowHover\"\n            :items-to-list=\"perList\"\n            :repeat=\"repeat\"\n            :has-drag=\"drag\"\n            :has-grayscale=\"gray\"\n            :has-opacity=\"opacity\" />\n    </section>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            arrow: true,\n            arrowHover: true,\n            drag: true,\n            gray: false,\n            opacity: false,\n            values: 1,\n            perList: 1,\n            repeat: false,\n            items: [\n                {\n                    title: 'Slide 1',\n                    image: 'https://picsum.photos/id/0/1230/500'\n                },\n                {\n                    title: 'Slide 2',\n                    image: 'https://picsum.photos/id/1/1230/500'\n                },\n                {\n                    title: 'Slide 3',\n                    image: 'https://picsum.photos/id/2/1230/500'\n                },\n                {\n                    title: 'Slide 4',\n                    image: 'https://picsum.photos/id/3/1230/500'\n                },\n                {\n                    title: 'Slide 5',\n                    image: 'https://picsum.photos/id/4/1230/500'\n                },\n                {\n                    title: 'Slide 6',\n                    image: 'https://picsum.photos/id/5/1230/500'\n                },\n                {\n                    title: 'Slide 7',\n                    image: 'https://picsum.photos/id/6/1230/500'\n                },\n                {\n                    title: 'Slide 8',\n                    image: 'https://picsum.photos/id/7/1230/500'\n                }\n            ]\n        }\n    }\n}\n</script>\n"

/***/ }),

/***/ 1335:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-carousel-list v-model=\"test\" :data=\"items\" :items-to-show=\"2\">\n        <template slot=\"item\" slot-scope=\"props\">\n            <div class=\"card\">\n                <div class=\"card-image\">\n                    <figure class=\"image is-5by4\">\n                        <a @click=\"info(props.index)\"><img :src=\"props.list.image\"></a>\n                    </figure>\n                    <b-tag type=\"is-danger\" rounded style=\"position: absolute; top: 0;\"><b>50%</b></b-tag>\n                </div>\n                <div class=\"card-content\">\n                    <div class=\"content\">\n                        <p class=\"title is-6\">{{ props.list.title }}</p>\n                        <p class=\"subtitle is-7\">@johnsmith</p>\n                        <div class=\"field is-grouped\" >\n                            <p class=\"control\" v-if=\"props.list.rating\">\n                                <b-rate :value=\"props.list.rating\" show-score disabled/>\n                            </p>\n                            <p class=\"control\" style=\"margin-left: auto\">\n                                <button class=\"button is-small is-danger is-outlined\"><b-icon size=\"is-small\" icon=\"heart\"/></button>\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </template>\n    </b-carousel-list>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            test: 0,\n            items: [\n                {\n                    title: 'Slide 1',\n                    image: 'https://buefy.org/static/img/placeholder-1280x960.png',\n                    rating: 4.4\n                },\n                {\n                    title: 'Slide 2',\n                    image: 'https://buefy.org/static/img/placeholder-1280x960.png',\n                    rating: 3.5\n                },\n                {\n                    title: 'Slide 3',\n                    image: 'https://buefy.org/static/img/placeholder-1280x960.png',\n                    rating: 5\n                },\n                {\n                    title: 'Slide 4',\n                    image: 'https://buefy.org/static/img/placeholder-1280x960.png'\n                },\n                {\n                    title: 'Slide 5',\n                    image: 'https://buefy.org/static/img/placeholder-1280x960.png',\n                    rating: 5\n                },\n                {\n                    title: 'Slide 6',\n                    image: 'https://buefy.org/static/img/placeholder-1280x960.png',\n                    rating: 4\n                },\n                {\n                    title: 'Slide 7',\n                    image: 'https://buefy.org/static/img/placeholder-1280x960.png',\n                    rating: 2.7\n                },\n                {\n                    title: 'Slide 8',\n                    image: 'https://buefy.org/static/img/placeholder-1280x960.png',\n                    rating: 1.5\n                }\n            ]\n        }\n    },\n    methods: {\n        info(value) {\n            this.test = value\n        }\n    }\n}\n</script>\n"

/***/ }),

/***/ 1336:
/***/ (function(module, exports) {

module.exports = "<template>\n    <b-carousel\n        :autoplay=\"false\"\n        with-carousel-list\n        :indicator=\"false\"\n        :overlay=\"gallery\">\n        <b-carousel-item v-for=\"(item, i) in items\" :key=\"i\">\n            <figure @click=\"switchGallery(true)\" class=\"image\">\n                <img :src=\"item.image\">\n            </figure>\n        </b-carousel-item>\n        <span v-if=\"gallery\" @click=\"switchGallery(false)\" class=\"modal-close is-large\"/>\n        <template slot=\"list\" slot-scope=\"props\">\n            <b-carousel-list\n                v-model=\"props.active\"\n                :data=\"items\"\n                :config=\"al\"\n                :refresh=\"gallery\"\n                @switch=\"props.switch($event, false)\"\n                as-indicator />\n        </template>\n        <template slot=\"overlay\">\n            <div class=\"has-text-centered has-text-white\">\n                Hello i'am overlay!\n            </div>\n        </template>\n    </b-carousel>\n</template>\n\n<script>\nexport default {\n    data() {\n        return {\n            gallery: false,\n            al: {\n                hasGrayscale: true,\n                itemsToShow: 2,\n                breakpoints: {\n                    768: {\n                        hasGrayscale: false,\n                        itemsToShow: 4\n                    },\n                    960: {\n                        hasGrayscale: true,\n                        itemsToShow: 6\n                    }\n                }\n            },\n            items: [\n                {\n                    title: 'Slide 1',\n                    image: 'https://picsum.photos/id/0/1230/500'\n                },\n                {\n                    title: 'Slide 2',\n                    image: 'https://picsum.photos/id/1/1230/500'\n                },\n                {\n                    title: 'Slide 3',\n                    image: 'https://picsum.photos/id/2/1230/500'\n                },\n                {\n                    title: 'Slide 4',\n                    image: 'https://picsum.photos/id/3/1230/500'\n                },\n                {\n                    title: 'Slide 5',\n                    image: 'https://picsum.photos/id/4/1230/500'\n                },\n                {\n                    title: 'Slide 6',\n                    image: 'https://picsum.photos/id/5/1230/500'\n                },\n                {\n                    title: 'Slide 7',\n                    image: 'https://picsum.photos/id/6/1230/500'\n                },\n                {\n                    title: 'Slide 8',\n                    image: 'https://picsum.photos/id/7/1230/500'\n                }\n            ]\n        }\n    },\n    methods: {\n        switchGallery(value) {\n            this.gallery = value\n            if (value) {\n                return document.documentElement.classList.add('is-clipped')\n            } else {\n                return document.documentElement.classList.remove('is-clipped')\n            }\n        }\n    }\n}\n</script>\n"

/***/ }),

/***/ 1337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('Example', {
    attrs: {
      "component": _vm.ExSimple,
      "code": _vm.ExSimpleCode,
      "paddingless": "",
      "vertical": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Custom",
      "component": _vm.ExFull,
      "code": _vm.ExFullCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Arrow",
      "component": _vm.ExArrow,
      "code": _vm.ExArrowCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Progress",
      "component": _vm.ExProgress,
      "code": _vm.ExProgressCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Indicator",
      "component": _vm.ExIndicator,
      "code": _vm.ExIndicatorCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _vm._m(1), _c('br'), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Custom Indicators",
      "component": _vm.ExCustomIndicator,
      "code": _vm.ExCustomIndicatorCode,
      "paddingless": ""
    }
  }, [_vm._v("\n            When images more than 6 add "), _c('code', [_vm._v("indicator-custom")]), _c('br'), _vm._v("\n            If want custom indicator to stay big, use "), _c('code', [_vm._v("is-medium")]), _vm._v(" on "), _c('code', [_vm._v("indicator-custom-size")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Switch like a gallery",
      "component": _vm.ExGallery,
      "code": _vm.ExGalleryCode,
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("You may also want to add "), _c('code', [_vm._v("is-clipped")]), _vm._v(" modifier to a containing element (usually "), _c('code', [_vm._v("html")]), _vm._v(") to stop scroll overflow.")])]), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Carousel List",
      "component": _vm.ExCarouselList,
      "code": _vm.ExCarouselListCode,
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("An imposing "), _c('strong', [_vm._v("carousel list")]), _vm._v(" to showcase viewer something.")]), _vm._v(" "), _c('div', {
    staticClass: "tags has-addons"
  }, [_c('span', {
    staticClass: "tag is-success"
  }, [_vm._v("New!")]), _vm._v(" "), _c('span', {
    staticClass: "tag is-info"
  }, [_vm._v("0.8.9")])])]), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Custom With Card",
      "component": _vm.ExWithCard,
      "code": _vm.ExWithCardCode,
      "paddingless": ""
    }
  }), _vm._v(" "), _c('Example', {
    attrs: {
      "title": "Custom as an indicators",
      "component": _vm.ExWithList,
      "code": _vm.ExWithListCode,
      "paddingless": ""
    }
  }, [_c('p', [_vm._v("With "), _c('strong', [_vm._v("Breakpoint")]), _vm._v(" and "), _c('strong', [_vm._v("Switch like a Gallery")]), _vm._v(".")])]), _vm._v(" "), _c('ApiView', {
    attrs: {
      "data": _vm.api
    }
  }), _vm._v(" "), _c('VariablesView', {
    attrs: {
      "data": _vm.variables
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('blockquote', [_vm._v("\n                Because images can take a few seconds to load (or not at all), use the "), _c('code', [_vm._v("image")]), _vm._v(" container to specify a "), _c('strong', [_vm._v("precisely sized")]), _vm._v("\n                container so that your layout isn't broken because of image loading or image errors - Bulma "), _c('a', {
    attrs: {
      "href": "https://bulma.io/documentation/elements/image/",
      "target": "_blank"
    }
  }, [_vm._v("image")]), _vm._v(".\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "has-text-centered"
  }, [_vm._v("Some source by "), _c('a', {
    attrs: {
      "href": "https://picsum.photos/",
      "target": "_blank"
    }
  }, [_vm._v("Picsum")]), _vm._v(" and Images from "), _c('a', {
    attrs: {
      "href": "https://unsplash.com/",
      "target": "_blank"
    }
  }, [_vm._v("Unsplash")]), _vm._v(".")])
}]}

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1326),
  /* template */
  __webpack_require__(1337),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 978:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            carousels: [{ text: 'Slide 1', color: 'primary' }, { text: 'Slide 2', color: 'info' }, { text: 'Slide 3', color: 'success' }, { text: 'Slide 4', color: 'warning' }, { text: 'Slide 5', color: 'danger' }]
        };
    }
});

/***/ }),

/***/ 979:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel', _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color))
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.text))])])])])
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            carousel: 0,
            animated: 'fade',
            drag: false,
            autoPlay: false,
            pauseHover: false,
            pauseInfo: false,
            pauseType: 'is-primary',
            interval: 3000,
            carousels: [{ title: 'Slide 1', color: 'dark' }, { title: 'Slide 2', color: 'primary' }, { title: 'Slide 3', color: 'info' }, { title: 'Slide 4', color: 'success' }, { title: 'Slide 5', color: 'warning' }, { title: 'Slide 6', color: 'danger' }]
        };
    },

    methods: {
        info: function info(value) {
            this.carousel = value;
            this.$buefy.toast.open({
                message: 'This Slide ' + value + ' !',
                type: 'is-info'
            });
        }
    }
});

/***/ }),

/***/ 981:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.autoPlay),
      callback: function($$v) {
        _vm.autoPlay = $$v
      },
      expression: "autoPlay"
    }
  }, [_vm._v("Autoplay")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.autoPlay
    },
    model: {
      value: (_vm.pauseHover),
      callback: function($$v) {
        _vm.pauseHover = $$v
      },
      expression: "pauseHover"
    }
  }, [_vm._v("Pause on hover")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.pauseHover
    },
    model: {
      value: (_vm.pauseInfo),
      callback: function($$v) {
        _vm.pauseInfo = $$v
      },
      expression: "pauseInfo"
    }
  }, [_vm._v("Pause info")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.drag),
      callback: function($$v) {
        _vm.drag = $$v
      },
      expression: "drag"
    }
  }, [_vm._v("Drag event")])], 1), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Value"
    }
  }, [_c('b-numberinput', {
    attrs: {
      "min": "0",
      "max": _vm.carousels.length - 1,
      "controls-position": "compact"
    },
    model: {
      value: (_vm.carousel),
      callback: function($$v) {
        _vm.carousel = $$v
      },
      expression: "carousel"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Interval"
    }
  }, [_c('b-numberinput', {
    attrs: {
      "min": "0",
      "controls-position": "compact",
      "step": "1000",
      "disabled": !_vm.autoPlay
    },
    model: {
      value: (_vm.interval),
      callback: function($$v) {
        _vm.interval = $$v
      },
      expression: "interval"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Animated"
    }
  }, [_c('b-field', [_c('b-radio-button', {
    attrs: {
      "native-value": "fade"
    },
    model: {
      value: (_vm.animated),
      callback: function($$v) {
        _vm.animated = $$v
      },
      expression: "animated"
    }
  }, [_vm._v("\n                            Fade\n                        ")]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "native-value": "slide"
    },
    model: {
      value: (_vm.animated),
      callback: function($$v) {
        _vm.animated = $$v
      },
      expression: "animated"
    }
  }, [_vm._v("\n                            Slide\n                        ")])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Pause Type"
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.pauseInfo
    },
    model: {
      value: (_vm.pauseType),
      callback: function($$v) {
        _vm.pauseType = $$v
      },
      expression: "pauseType"
    }
  }, [_c('option', {
    attrs: {
      "value": "is-white"
    }
  }, [_vm._v("is-white")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-dark"
    }
  }, [_vm._v("is-dark")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-primary"
    }
  }, [_vm._v("is-primary")])])], 1)], 1)], 1), _vm._v(" "), _c('b-carousel', {
    attrs: {
      "animated": _vm.animated,
      "has-drag": _vm.drag,
      "autoplay": _vm.autoPlay,
      "pause-hover": _vm.pauseHover,
      "pause-info": _vm.pauseInfo,
      "pause-info-type": _vm.pauseType,
      "interval": _vm.interval
    },
    on: {
      "change": function($event) {
        _vm.info($event)
      }
    },
    model: {
      value: (_vm.carousel),
      callback: function($$v) {
        _vm.carousel = $$v
      },
      expression: "carousel"
    }
  }, _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color) + " is-bold")
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.title))])])])])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 982:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            arrow: true,
            arrowBoth: false,
            arrowHover: false,
            iconPack: 'mdi',
            iconPrev: 'arrow-left',
            iconNext: 'arrow-right',
            iconSize: '',
            carousels: [{ title: 'Slide 1', color: 'info' }, { title: 'Slide 2', color: 'success' }, { title: 'Slide 3', color: 'warning' }, { title: 'Slide 4', color: 'danger' }]
        };
    }
});

/***/ }),

/***/ 983:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.arrow),
      callback: function($$v) {
        _vm.arrow = $$v
      },
      expression: "arrow"
    }
  }, [_c('strong', [_vm._v("Arrow")])]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.arrow
    },
    model: {
      value: (_vm.arrowBoth),
      callback: function($$v) {
        _vm.arrowBoth = $$v
      },
      expression: "arrowBoth"
    }
  }, [_vm._v("Both")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.arrow
    },
    model: {
      value: (_vm.arrowHover),
      callback: function($$v) {
        _vm.arrowHover = $$v
      },
      expression: "arrowHover"
    }
  }, [_vm._v("Hover")])], 1), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Icon Pack"
    }
  }, [_c('b-input', {
    attrs: {
      "placeholder": "e.g. mdi, fa or other"
    },
    model: {
      value: (_vm.iconPack),
      callback: function($$v) {
        _vm.iconPack = $$v
      },
      expression: "iconPack"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Icon Size"
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.iconSize),
      callback: function($$v) {
        _vm.iconSize = $$v
      },
      expression: "iconSize"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("default")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-small"
    }
  }, [_vm._v("is-small")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-medium"
    }
  }, [_vm._v("is-medium")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-large"
    }
  }, [_vm._v("is-large")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Icon Prev"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.iconPrev),
      callback: function($$v) {
        _vm.iconPrev = $$v
      },
      expression: "iconPrev"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Icon Next"
    }
  }, [_c('b-input', {
    model: {
      value: (_vm.iconNext),
      callback: function($$v) {
        _vm.iconNext = $$v
      },
      expression: "iconNext"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-carousel', {
    attrs: {
      "arrow": _vm.arrow,
      "arrow-both": _vm.arrowBoth,
      "arrow-hover": _vm.arrowHover,
      "icon-pack": _vm.iconPack,
      "icon-prev": _vm.iconPrev,
      "icon-next": _vm.iconNext,
      "icon-size": _vm.iconSize
    }
  }, _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color))
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.title))])])])])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 984:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            progress: true,
            progressType: 'is-primary',
            carousels: [{ title: 'Slide 1', color: 'grey' }, { title: 'Slide 2', color: 'dark' }, { title: 'Slide 3', color: 'primary' }, { title: 'Slide 4', color: 'info' }]
        };
    }
});

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', [_c('b-switch', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }, [_c('strong', [_vm._v("Progress")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Type",
      "label-position": "on-border"
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.progress
    },
    model: {
      value: (_vm.progressType),
      callback: function($$v) {
        _vm.progressType = $$v
      },
      expression: "progressType"
    }
  }, [_c('option', {
    attrs: {
      "value": "is-primary"
    }
  }, [_vm._v("is-primary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-info"
    }
  }, [_vm._v("is-info")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-success"
    }
  }, [_vm._v("is-success")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-warning"
    }
  }, [_vm._v("is-warning")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-danger"
    }
  }, [_vm._v("is-danger")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-white"
    }
  }, [_vm._v("is-white")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-light"
    }
  }, [_vm._v("is-light")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-dark"
    }
  }, [_vm._v("is-dark")])])], 1)], 1)], 1), _vm._v(" "), _c('b-carousel', {
    attrs: {
      "progress": _vm.progress,
      "progress-type": _vm.progressType
    }
  }, _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color))
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.title))])])])])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 986:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            indicator: true,
            indicatorBackground: true,
            indicatorInside: true,
            indicatorMode: 'hover',
            indicatorPosition: 'is-top',
            indicatorStyle: 'is-lines',
            carousels: [{ title: 'Slide 1', color: 'info' }, { title: 'Slide 2', color: 'success' }, { title: 'Slide 3', color: 'warning' }, { title: 'Slide 4', color: 'danger' }]
        };
    }
});

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.indicator),
      callback: function($$v) {
        _vm.indicator = $$v
      },
      expression: "indicator"
    }
  }, [_c('strong', [_vm._v("Indicator")])]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorBackground),
      callback: function($$v) {
        _vm.indicatorBackground = $$v
      },
      expression: "indicatorBackground"
    }
  }, [_vm._v("Background")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorInside),
      callback: function($$v) {
        _vm.indicatorInside = $$v
      },
      expression: "indicatorInside"
    }
  }, [_vm._v("Inside")])], 1), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Position",
      "disabled": !_vm.indicator
    }
  }, [_c('b-select', {
    model: {
      value: (_vm.indicatorPosition),
      callback: function($$v) {
        _vm.indicatorPosition = $$v
      },
      expression: "indicatorPosition"
    }
  }, [_c('option', {
    attrs: {
      "value": "is-bottom"
    }
  }, [_vm._v("is-bottom")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-top"
    }
  }, [_vm._v("is-top")])])], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Mode"
    }
  }, [_c('b-field', [_c('b-radio-button', {
    attrs: {
      "native-value": "click",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorMode),
      callback: function($$v) {
        _vm.indicatorMode = $$v
      },
      expression: "indicatorMode"
    }
  }, [_c('span', [_vm._v("Click")])]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "native-value": "hover",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorMode),
      callback: function($$v) {
        _vm.indicatorMode = $$v
      },
      expression: "indicatorMode"
    }
  }, [_c('span', [_vm._v("Hover")])])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Style"
    }
  }, [_c('b-field', [_c('b-radio-button', {
    attrs: {
      "native-value": "is-boxs",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorStyle),
      callback: function($$v) {
        _vm.indicatorStyle = $$v
      },
      expression: "indicatorStyle"
    }
  }, [_c('span', [_vm._v("Boxs")])]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "native-value": "is-dots",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorStyle),
      callback: function($$v) {
        _vm.indicatorStyle = $$v
      },
      expression: "indicatorStyle"
    }
  }, [_c('span', [_vm._v("Dots")])]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "native-value": "is-lines",
      "disabled": !_vm.indicator
    },
    model: {
      value: (_vm.indicatorStyle),
      callback: function($$v) {
        _vm.indicatorStyle = $$v
      },
      expression: "indicatorStyle"
    }
  }, [_c('span', [_vm._v("Lines")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-carousel', {
    attrs: {
      "indicator": _vm.indicator,
      "indicator-background": _vm.indicatorBackground,
      "indicator-inside": _vm.indicatorInside,
      "indicator-mode": _vm.indicatorMode,
      "indicator-position": _vm.indicatorPosition,
      "indicator-style": _vm.indicatorStyle
    }
  }, _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color))
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.title))])])])])
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 988:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(989);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(900)("5c403104", content, true);

/***/ }),

/***/ 989:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(899)(true);
// imports


// module
exports.push([module.i, "\n.is-active .al img {\n    filter: grayscale(0%);\n}\n.al img {\n    filter: grayscale(100%);\n}\n", "", {"version":3,"sources":["/root/Awesome-UI/buefy/docs/pages/components/carousel/examples/ExCustomIndicator.vue"],"names":[],"mappings":";AACA;IACI,sBAAsB;CACzB;AACD;IACI,wBAAwB;CAC3B","file":"ExCustomIndicator.vue","sourcesContent":["\n.is-active .al img {\n    filter: grayscale(0%);\n}\n.al img {\n    filter: grayscale(100%);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 990:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    methods: {
        getImgUrl: function getImgUrl(value) {
            return "https://picsum.photos/id/43" + value + "/1230/500";
        }
    }
});

/***/ }),

/***/ 991:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel', {
    attrs: {
      "indicator-inside": false
    },
    scopedSlots: _vm._u([{
      key: "indicators",
      fn: function(props) {
        return [_c('span', {
          staticClass: "al image"
        }, [_c('img', {
          attrs: {
            "src": _vm.getImgUrl(props.i),
            "title": props.i
          }
        })])]
      }
    }])
  }, _vm._l((6), function(item, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('span', {
      staticClass: "image"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgUrl(i)
      }
    })])])
  }), 1)
},staticRenderFns: []}

/***/ }),

/***/ 992:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(993);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(900)("4ff25bc6", content, true);

/***/ }),

/***/ 993:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(899)(true);
// imports


// module
exports.push([module.i, "\n.is-active .al img {\n    border: 1px solid #fff;\n    filter: grayscale(0%);\n}\n.al img {\n    border: 1px solid transparent;\n    filter: grayscale(100%);\n}\n", "", {"version":3,"sources":["/root/Awesome-UI/buefy/docs/pages/components/carousel/examples/ExGallery.vue"],"names":[],"mappings":";AACA;IACI,uBAAuB;IACvB,sBAAsB;CACzB;AACD;IACI,8BAA8B;IAC9B,wBAAwB;CAC3B","file":"ExGallery.vue","sourcesContent":["\n.is-active .al img {\n    border: 1px solid #fff;\n    filter: grayscale(0%);\n}\n.al img {\n    border: 1px solid transparent;\n    filter: grayscale(100%);\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 994:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            gallery: false
        };
    },

    methods: {
        getImgUrl: function getImgUrl(value) {
            value += 50;
            return 'https://picsum.photos/id/10' + value + '/1230/500';
        },
        switchGallery: function switchGallery(value) {
            this.gallery = value;
            if (value) {
                return document.documentElement.classList.add('is-clipped');
            } else {
                return document.documentElement.classList.remove('is-clipped');
            }
        }
    }
});

/***/ }),

/***/ 995:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel', {
    attrs: {
      "autoplay": false,
      "indicator-custom": "",
      "indicator-inside": false,
      "overlay": _vm.gallery
    },
    scopedSlots: _vm._u([{
      key: "indicators",
      fn: function(props) {
        return [_c('figure', {
          staticClass: "al image",
          attrs: {
            "draggable": false
          }
        }, [_c('img', {
          attrs: {
            "draggable": false,
            "src": _vm.getImgUrl(props.i),
            "title": props.i
          }
        })])]
      }
    }])
  }, [_vm._l((20), function(item, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('a', {
      staticClass: "image ",
      on: {
        "click": function($event) {
          _vm.switchGallery(true)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgUrl(i)
      }
    })])])
  }), _vm._v(" "), (_vm.gallery) ? _c('span', {
    staticClass: "modal-close is-large",
    on: {
      "click": function($event) {
        _vm.switchGallery(false)
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 996:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            arrow: true,
            arrowHover: true,
            drag: true,
            gray: false,
            opacity: false,
            values: 1,
            perList: 1,
            repeat: false,
            items: [{
                title: 'Slide 1',
                image: 'https://picsum.photos/id/0/1230/500'
            }, {
                title: 'Slide 2',
                image: 'https://picsum.photos/id/1/1230/500'
            }, {
                title: 'Slide 3',
                image: 'https://picsum.photos/id/2/1230/500'
            }, {
                title: 'Slide 4',
                image: 'https://picsum.photos/id/3/1230/500'
            }, {
                title: 'Slide 5',
                image: 'https://picsum.photos/id/4/1230/500'
            }, {
                title: 'Slide 6',
                image: 'https://picsum.photos/id/5/1230/500'
            }, {
                title: 'Slide 7',
                image: 'https://picsum.photos/id/6/1230/500'
            }, {
                title: 'Slide 8',
                image: 'https://picsum.photos/id/7/1230/500'
            }]
        };
    }
});

/***/ }),

/***/ 997:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.arrow),
      callback: function($$v) {
        _vm.arrow = $$v
      },
      expression: "arrow"
    }
  }, [_vm._v("Arrow")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.arrow
    },
    model: {
      value: (_vm.arrowHover),
      callback: function($$v) {
        _vm.arrowHover = $$v
      },
      expression: "arrowHover"
    }
  }, [_vm._v("Arrow on hover")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.drag),
      callback: function($$v) {
        _vm.drag = $$v
      },
      expression: "drag"
    }
  }, [_vm._v("Drag event")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": _vm.opacity
    },
    model: {
      value: (_vm.gray),
      callback: function($$v) {
        _vm.gray = $$v
      },
      expression: "gray"
    }
  }, [_vm._v("Grayscale")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": _vm.gray
    },
    model: {
      value: (_vm.opacity),
      callback: function($$v) {
        _vm.opacity = $$v
      },
      expression: "opacity"
    }
  }, [_vm._v("Opacity")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.repeat),
      callback: function($$v) {
        _vm.repeat = $$v
      },
      expression: "repeat"
    }
  }, [_vm._v("Repeat")])], 1), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Value"
    }
  }, [_c('b-numberinput', {
    attrs: {
      "min": "0",
      "max": _vm.items.length - 1,
      "controls-position": "compact"
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Items to List"
    }
  }, [_c('b-numberinput', {
    attrs: {
      "min": "0",
      "max": _vm.items.length - 1,
      "controls-position": "compact"
    },
    model: {
      value: (_vm.perList),
      callback: function($$v) {
        _vm.perList = $$v
      },
      expression: "perList"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-carousel-list', {
    attrs: {
      "data": _vm.items,
      "arrow": _vm.arrow,
      "arrow-hover": _vm.arrowHover,
      "items-to-list": _vm.perList,
      "repeat": _vm.repeat,
      "has-drag": _vm.drag,
      "has-grayscale": _vm.gray,
      "has-opacity": _vm.opacity
    },
    model: {
      value: (_vm.values),
      callback: function($$v) {
        _vm.values = $$v
      },
      expression: "values"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 998:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            test: 0,
            items: [{
                title: 'Slide 1',
                image: 'https://buefy.org/static/img/placeholder-1280x960.png',
                rating: 4.4
            }, {
                title: 'Slide 2',
                image: 'https://buefy.org/static/img/placeholder-1280x960.png',
                rating: 3.5
            }, {
                title: 'Slide 3',
                image: 'https://buefy.org/static/img/placeholder-1280x960.png',
                rating: 5
            }, {
                title: 'Slide 4',
                image: 'https://buefy.org/static/img/placeholder-1280x960.png'
            }, {
                title: 'Slide 5',
                image: 'https://buefy.org/static/img/placeholder-1280x960.png',
                rating: 5
            }, {
                title: 'Slide 6',
                image: 'https://buefy.org/static/img/placeholder-1280x960.png',
                rating: 4
            }, {
                title: 'Slide 7',
                image: 'https://buefy.org/static/img/placeholder-1280x960.png',
                rating: 2.7
            }, {
                title: 'Slide 8',
                image: 'https://buefy.org/static/img/placeholder-1280x960.png',
                rating: 1.5
            }]
        };
    },

    methods: {
        info: function info(value) {
            this.test = value;
        }
    }
});

/***/ }),

/***/ 999:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-carousel-list', {
    attrs: {
      "data": _vm.items,
      "items-to-show": 2
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_c('div', {
          staticClass: "card"
        }, [_c('div', {
          staticClass: "card-image"
        }, [_c('figure', {
          staticClass: "image is-5by4"
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.info(props.index)
            }
          }
        }, [_c('img', {
          attrs: {
            "src": props.list.image
          }
        })])]), _vm._v(" "), _c('b-tag', {
          staticStyle: {
            "position": "absolute",
            "top": "0"
          },
          attrs: {
            "type": "is-danger",
            "rounded": ""
          }
        }, [_c('b', [_vm._v("50%")])])], 1), _vm._v(" "), _c('div', {
          staticClass: "card-content"
        }, [_c('div', {
          staticClass: "content"
        }, [_c('p', {
          staticClass: "title is-6"
        }, [_vm._v(_vm._s(props.list.title))]), _vm._v(" "), _c('p', {
          staticClass: "subtitle is-7"
        }, [_vm._v("@johnsmith")]), _vm._v(" "), _c('div', {
          staticClass: "field is-grouped"
        }, [(props.list.rating) ? _c('p', {
          staticClass: "control"
        }, [_c('b-rate', {
          attrs: {
            "value": props.list.rating,
            "show-score": "",
            "disabled": ""
          }
        })], 1) : _vm._e(), _vm._v(" "), _c('p', {
          staticClass: "control",
          staticStyle: {
            "margin-left": "auto"
          }
        }, [_c('button', {
          staticClass: "button is-small is-danger is-outlined"
        }, [_c('b-icon', {
          attrs: {
            "size": "is-small",
            "icon": "heart"
          }
        })], 1)])])])])])]
      }
    }]),
    model: {
      value: (_vm.test),
      callback: function($$v) {
        _vm.test = $$v
      },
      expression: "test"
    }
  })
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/3.08d90754facc74697f78.js